import React from 'react';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import { setInitialPageLoadTimingFromPerformanceMarks } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools/index.tsx';
import type { MatchedRoute, Route } from '@atlassian/react-resource-router';
import View from './view/index.tsx';

export type Props = {
	initRoute: MatchedRoute | null;
	routes: Route[];
};

const onSpaShellReady = () => {
	setInitialPageLoadTimingFromPerformanceMarks(
		'jira-spa/spa-shell/core',
		'_jira-spa/spa-shell.start',
		'JIRA_SPA_SHELL_READY',
	);
};

const Spa = ({ initRoute = null, routes }: Props): React.JSX.Element => (
	<>
		<PerformanceMark metricKey="JIRA_SPA_SHELL_READY" onSet={onSpaShellReady} />
		<View initRoute={initRoute} routes={routes} />
	</>
);

export default Spa;
